export const DEVICESIZE = {
    mobileS:   '360px',
    mobileL:   '480px',
    tablet:    '736px',
    desktopS:  '980px',
    desktopM: '1280px',
    desktopL: '1680px',
}